import React from 'react';
import { CtaButton } from './CtaButton';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/aa700a46-bb75-40bd-b929-f892cffbe423.jpg';
export function Hero() {
  return <header className="border-b border-paper-line bg-paper px-5 pb-16 pt-16 sm:pb-20 sm:pt-20 lg:px-8 lg:pb-24 lg:pt-24" data-id="element-109" data-mp="9ka2qpx8ocsp">
      <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-[1.05fr_1fr] lg:gap-16" data-id="element-110" data-mp="4n1kyqg06arz">
        <div data-id="element-111" data-mp="12862k3i3uktp">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-112" data-mp="128pijeo72z53">
            Megapack · El Sistema Entrenador 360°
          </p>

          <h1 className="display mt-5 text-[2.5rem] text-ink sm:text-5xl lg:text-[4.25rem]" data-id="element-113" data-mp="sai4p4p7cx7b">
            Sos el primero en llegar
            <br data-id="element-114" data-mp="nboov5mg0u3z" />
            y el último en irte.
            <br data-id="element-115" data-mp="3d1a9nnfemhev" />
            <span className="text-grass" data-id="element-116" data-mp="3d1sbczku5nu6">
              ¿No es hora de que tu equipo juegue como vos soñás?
            </span>
          </h1>

          <p className="mt-7 max-w-xl text-lg leading-relaxed text-ink-soft sm:text-xl" data-id="element-117" data-mp="3814brpijjyoc">
            Dejá de ser <span className="font-semibold text-ink" data-id="element-118" data-mp="3j6fy7px5bddu">"el que pone los conos"</span>{' '}
            y convertite en el estratega que los otros clubes quieren contratar.
          </p>

          <div className="mt-9 flex flex-col items-start gap-4" data-id="element-119" data-mp="399tcz00wqkba">
            <CtaButton size="lg" data-id="element-120" data-mp="3e8mtz2fektg7">Quiero el sistema completo</CtaButton>
            <p className="text-sm text-ink-dim" data-id="element-121" data-mp="30i17z4unk3e3">
              Pago único de <span className="font-bold text-ink" data-id="element-122" data-mp="30ggab6d1k4c0">$24.999</span> ·
              Mercado Pago · acceso inmediato vía mail
            </p>
          </div>
        </div>

        <div className="relative" data-id="element-123" data-mp="2qkmt39odnmnw">
          <img src={HERO_IMAGE} alt="Un entrenador solo en una cancha de barrio al atardecer, con una pelota bajo el brazo" className="aspect-[4/3] w-full rounded-xl object-cover shadow-xl lg:aspect-[3/4]" data-id="element-124" data-mp="2qloh0eqhs3n1" />
          <p className="absolute bottom-4 left-4 right-4 rounded-md bg-ink/85 px-4 py-3 text-sm font-medium text-white backdrop-blur-sm" data-id="element-125" data-mp="2lla52llrs9jq">
            Última práctica de la semana. Y otra vez, planificando en el aire.
          </p>
        </div>
      </div>
    </header>;
}